import { EnumTableConfig } from '@/components/table/_fieldDefinitions/enum/EnumTableConfig.ts';
import { toneEnumConfig } from '@/components/table/_fieldDefinitions/enum/enumToneConfig.ts';
import { StatusTone } from '@/components/ui/statusTone.ts';
import {
  ArrowDownLeft,
  ArrowUpRight,
  Ban,
  CheckCircle,
  Clock,
} from 'lucide-react';
import {
  TransactionDirection,
  RawTransactionStatus,
} from './RawTransactionStatus.ts';

export const rawTransactionStatusLabels: Record<RawTransactionStatus, string> =
  {
    [RawTransactionStatus.PENDING]: 'Oczekująca',
    [RawTransactionStatus.MATCHED_AUTO]: 'Dopasowana auto.',
    [RawTransactionStatus.MATCHED_MANUAL]: 'Dopasowana ręcznie',
    [RawTransactionStatus.IGNORED]: 'Zignorowana',
  };

export const rawTransactionStatusTones: Record<
  RawTransactionStatus,
  StatusTone
> = {
  [RawTransactionStatus.PENDING]: 'info',
  [RawTransactionStatus.MATCHED_AUTO]: 'success',
  [RawTransactionStatus.MATCHED_MANUAL]: 'success',
  [RawTransactionStatus.IGNORED]: 'neutral',
};

export const rawTransactionStatusTableConfig: EnumTableConfig = {
  [RawTransactionStatus.PENDING]: toneEnumConfig(
    rawTransactionStatusLabels[RawTransactionStatus.PENDING],
    rawTransactionStatusTones[RawTransactionStatus.PENDING],
    Clock,
  ),
  [RawTransactionStatus.MATCHED_AUTO]: toneEnumConfig(
    rawTransactionStatusLabels[RawTransactionStatus.MATCHED_AUTO],
    rawTransactionStatusTones[RawTransactionStatus.MATCHED_AUTO],
    CheckCircle,
  ),
  [RawTransactionStatus.MATCHED_MANUAL]: toneEnumConfig(
    rawTransactionStatusLabels[RawTransactionStatus.MATCHED_MANUAL],
    rawTransactionStatusTones[RawTransactionStatus.MATCHED_MANUAL],
    CheckCircle,
  ),
  [RawTransactionStatus.IGNORED]: toneEnumConfig(
    rawTransactionStatusLabels[RawTransactionStatus.IGNORED],
    rawTransactionStatusTones[RawTransactionStatus.IGNORED],
    Ban,
  ),
};

/*
 * Ta sama para strzałek co przy kwocie na liście transakcji: wyciąg i lista to
 * dla operatora jeden temat, a `TrendingUp/Down` czytało się tam jak wykres.
 * Enum kierunku jest osobny po obu stronach, więc powtarzamy ikony, nie import.
 */
export const rawTransactionDirectionTableConfig: EnumTableConfig = {
  [TransactionDirection.INCOMING]: {
    ...toneEnumConfig('Przychodzący', 'success', ArrowDownLeft),
    tooltip: 'Przychodzący',
    displayMode: 'icon',
  },
  [TransactionDirection.OUTGOING]: {
    ...toneEnumConfig('Wychodzący', 'error', ArrowUpRight),
    tooltip: 'Wychodzący',
    displayMode: 'icon',
  },
};
